import type { Distributor } from "@shared/types/Distributor";
import { cloneDeep } from "lodash";

export const getAddressString = (distributor: Distributor): string => {
  return [[distributor.address1, distributor.city].join(" "), distributor.state]
    .filter(value => !!value && value.trim() != "")
    .join(", ");
};

export const isAutoAssignedToRetailer = (distributor: Distributor): boolean => {
  return (
    distributor.default_sales_rep &&
    distributor.sales_reps &&
    distributor.sales_reps.length === 1 &&
    distributor.default_sales_rep.id === distributor.sales_reps[0].id &&
    !distributor.sales_reps[0].retailer_direct_add &&
    !distributor.sales_reps[0].has_received_order &&
    !distributor.retailer_direct_add
  );
};

export const sortedDistributors = (distributors: Distributor[]): Distributor[] => {
  const sortedDistributors = cloneDeep(distributors);
  sortedDistributors.sort((d1, d2) => {
    if (d1.name > d2.name) return 1;
    if (d1.name < d2.name) return -1;
    return 0;
  });
  return sortedDistributors;
};